export default __webpack_public_path__ + "static/media/search.67e44100.svg";